<template>
  <div class="section" id="faq">
    <div class="top">
      <div class="title">Frequently asked questions</div>
    </div>
    <div class="bottom">
      <div class="faq_group">
        <div class="faq_title">General</div>
        <div class="tab">
          <input type="checkbox" id="faq_1" />
          <label class="tab-label" for="faq_1">What is learn online?</label>
          <div class="tab-content">
            Whether it be in business and leadership, photography, cooking,
            writing, acting, music, sports and more, MasterClass delivers a
            world class online learning experience. Video lessons are available
            anytime, anywhere on your smartphone, personal computer, Apple TV
            and FireTV streaming media players.
          </div>
        </div>
        <div class="tab">
          <input type="checkbox" id="faq_2" />
          <label class="tab-label" for="faq_2"
            >How does the 30-day guarantee work?</label
          >
          <div class="tab-content">
            Our goal is to make sure that you have the best learning experience
            possible. If MasterClass isn’t for you, then email us within 30 days
            of the date you purchase your subscription, and we’ll offer a full
            refund.
          </div>
        </div>
      </div>
      <div class="faq_group">
        <div class="faq_title">Pricing & Payment</div>
        <div class="tab">
          <input type="checkbox" id="faq_3" />
          <label class="tab-label" for="faq_3"
            >Which classes are right for me?</label
          >
          <div class="tab-content">
            Variety of categories, including business and leadership,
            photography, cooking, writing, acting, music, sports and more. Every
            class has been designed to be accessible for people with little to
            no experience and advanced students alike. With new classes
            launching regulary, you can learn practical skills, ignite new
            passions, and get everyday wisdom.
          </div>
        </div>
        <div class="tab">
          <input type="checkbox" id="faq_4" />
          <label class="tab-label" for="faq_4"
            >How does the 30-day guarantee work?</label
          >
          <div class="tab-content">
            Our goal is to make sure that you have the best learning experience
            possible. If MasterClass isn’t for you, then email us within 30 days
            of the date you purchase your subscription, and we’ll offer a full
            refund.
          </div>
        </div>
        <div class="tab">
          <input type="checkbox" id="faq_5" />
          <label class="tab-label" for="faq_5"> What is learn online?</label>
          <div class="tab-content">
            Whether it be in business and leadership, photography, cooking,
            writing, acting, music, sports and more, MasterClass delivers a
            world class online learning experience. Video lessons are available
            anytime, anywhere on your smartphone, personal computer, Apple TV
            and FireTV streaming media players.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {},
  },
};
</script>
<style>
.section#faq {
  padding: 1rem 2.5rem;
  min-height: calc(100vh - 75px);
  padding-top: 6rem;
}
.section#faq .top {
  width: 100%;
  text-align: center;
}
.section#faq .top .title {
  font-size: 3rem;
  font-family: "Volkhov", serif;
  font-weight: 400;
  margin-bottom: 3rem;
}
.section#faq .bottom {
  margin-left: auto;
  margin-right: auto;
  width: 70%;
}
.section#faq .faq_group {
  padding: 2rem 2rem 1rem 2rem;
}
.section#faq .faq_title {
  margin-bottom: 1rem;
  color: #545a66;
}
.section#faq .tab {
  width: 100%;
  overflow: hidden;
  margin-bottom: 1rem;
}
.section#faq input {
  display: none;
}
.section#faq .tab-label {
  display: flex;
  justify-content: space-between;
  background-color: #eff2f8;
  font-weight: 600;
  cursor: pointer;
  padding: 1rem;
  border-radius: 5px;
  transition: all 0.3s;
}
.section#faq .tab-label:hover {
  background-color: #e7ecf5;
  transition: background-color 0.3s;
}
.section#faq .tab-label::after {
  content: "\276F";
  text-align: center;
  transition: all 0.35s;
}
.section#faq .tab-content {
  max-height: 0;
  padding: 0rem 1rem;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  color: #545a66;
  text-align: left;
  background: #eff2f8;
  transition: all 0.3s;
  cursor: pointer;
}

.section#faq input:checked + .tab-label {
  background: #e7ecf5;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.section#faq input:checked + .tab-label::after {
  transform: rotate(90deg);
}
.section#faq input:checked ~ .tab-content {
  max-height: 100vh;
  padding: 0rem 1rem 1rem 1rem;
  background: #e7ecf5;
}
</style>